@if (items) {
    <dl [class]="classNames">
        @for (item of items; track item) {
            <div class="sh-inline-description-list__item">
                <dt class="sh-inline-description-list__term" [title]="item.icon?.iconOnly ? item.term : ''">
                    @if (item.icon) {
                        <svg
                            sh-icon
                            [name]="item.icon?.name"
                            [size]="item.icon?.size || defaultIconSize"
                            class="sh-inline-description-list__term__icon"
                            aria-hidden="true"
                        ></svg>
                    }
                    <span [ngClass]="{ 'sh-visually-hidden': item.icon?.iconOnly }">{{ item.term }}</span>
                </dt>
                <dd
                    class="sh-inline-description-list__details"
                    [ngClass]="{
                        '-sh-diminish': item.icon?.iconOnly || item.navigationLink || inlineDescriptionListAsDetailsGuard(item) || diminish,
                        '-sh-full-width': fullWidth
                    }"
                    [title]="inlineDescriptionListAsDetailsGuard(item) ? '' : item.details"
                >
                    @if (
                        baseInlineDescriptionListItemGuard(item) &&
                        !navigationLinkInlineDescriptionListItemGuard(item) &&
                        !eventListenerInlineDescriptionListItemGuard(item)
                    ) {
                        <ng-container *ngTemplateOutlet="itemDetailsDefault; context: { item: item }"></ng-container>
                    }
                    @if (navigationLinkInlineDescriptionListItemGuard(item)) {
                        <ng-container *ngTemplateOutlet="itemDetailsWithLink; context: { item: item }"></ng-container>
                    }
                    @if (eventListenerInlineDescriptionListItemGuard(item)) {
                        <ng-container *ngTemplateOutlet="itemDetailsWithEventListener; context: { item: item }"></ng-container>
                    }
                </dd>
            </div>
        }
    </dl>
}

<ng-template #itemDetailsDefault let-item="item">
    <ng-container *ngTemplateOutlet="itemDetails; context: { item: item }"></ng-container>
</ng-template>

<ng-template #itemDetailsWithLink let-item="item">
    <a [shNavigationLink]="item.navigationLink" class="sh-link" [title]="item.details">
        <ng-container *ngTemplateOutlet="itemDetails; context: { item: item }"></ng-container>
    </a>
</ng-template>

<ng-template #itemDetailsWithEventListener let-item="item">
    <button type="button" class="sh-link" (click)="handleClick($event, item)" [title]="item.details">
        <ng-container *ngTemplateOutlet="itemDetails; context: { item: item }"></ng-container>
    </button>
</ng-template>

<ng-template #itemDetails let-item="item">
    @if (inlineDescriptionListAsDetailsGuard(item)) {
        <sh-inline-description-list [items]="item.details" [direction]="direction" [fontSize]="fontSize" [diminish]="true"></sh-inline-description-list>
    } @else {
        {{ item.details }}
    }
</ng-template>
